import React, { useEffect, useState } from "react";

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (scrollY / totalHeight) * 100;
      setShowButton(scrolled > 30); // Show after 30% scroll
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return showButton ? (
    <button
      onClick={scrollToTop}
      className="scroll-to-top-neu"
      title="Back to Top"
    >
       <i className="fas fa-arrow-up"></i>
    </button>
  ) : null;
};

export default ScrollToTopButton;
